/* eslint-disable no-unused-vars */

// eslint-disable-next-line no-shadow
export enum SensorsType {
  /**
   * 神策埋点
   * @value init_behavior_code
   * @Infomation 生成用户访问回话id
   */
  init_behavior_code = 'init_behavior_code',

  /**
   * 神策埋点
   * @value visit_landing_page
   * @Infomation 用户访问落地页
   */
  visit_landing_page = 'visit_landing_page',

  /** 访问小程序中转页，使用公共参数，渠道码取本次链接 */
  visit_mini_program_page = 'visit_mini_program_page',

  /** 点击打开小程序，使用公共参数，渠道码取本次链接 */
  click_open_mini_program = 'click_open_mini_program',

  /**
   * 神策埋点
   * @value cilck_get_verification_code
   * @Infomation 用户获取验证码
   */
  cilck_get_verification_code = 'cilck_get_verification_code',

  /**
   * 神策埋点
   * @value click_login
   * @Infomation 户点击登录
   */
  click_login = 'click_login',

  /**
   * 神策埋点
   * @value visit_form_page
   * @Infomation 用户访问表单页
   */
  visit_form_page = 'visit_form_page',

  /**
   * 神策埋点
   * @value click_submit_form_info
   * @Infomation 用户点击提交表单
   */
  click_submit_form_info = 'click_submit_form_info',

  /**
   * 神策埋点
   * @value visit_authorization_page
   * @Infomation 用户访问授权页
   */
  visit_authorization_page = 'visit_authorization_page',

  /**
   * 神策埋点
   * @value click_authorize
   * @Infomation 用户点击授权
   */
  click_authorize = 'click_authorize',

  /**
   * 神策埋点
   * @value visit_result_page
   * @Infomation 用户访问结果页
   */
  visit_result_page = 'visit_result_page',

  /**
   * 神策埋点
   * @value click_download_app
   * @Infomation 用户点击下载 App
   */
  click_download_app = 'click_download_app',

  /**
   * 神策埋点
   * @value click_wechat_download_app
   * @Infomation 微信环境用户点击下载 App
   */
  click_wechat_download_app = 'click_wechat_download_app',

  /**
   * 神策埋点
   * @value click_backend_h5_product
   * @Infomation 用户点击后端 H5 产品
   */
  click_backend_h5_product = 'click_backend_h5_product',

  /**
   * 神策埋点
   * @value open_backend_product_new_tab
   * @Infomation 后端产品打开新标签页结果
   */
  open_backend_product_new_tab = 'open_backend_product_new_tab',

  /**
   * 神策埋点
   * @value visit_retention_popup
   * @Infomation 访问挽留弹窗
   */
  visit_retention_popup = 'visit_retention_popup',

  /**
   * 神策埋点
   * @value visit_re_authorization_page
   * @Infomation 用户二次访问授权页
   */
  visit_re_authorization_page = 'visit_re_authorization_page',

  /**
   * 神策埋点
   * @value click_re_authorize
   * @Infomation 用户二次匹配点击授权
   */
  click_re_authorize = 'click_re_authorize',

  /**
   * 神策埋点
   * @value form_stay_pop
   * @Infomation 访问表单流程4表单页挽留弹窗
   */
  visit_form_stay_pop = 'visit_form_stay_pop',

  /**
   * 神策埋点
   * @value form_stay_pop
   * @Infomation 访问表单流程4表单页挽留表单
   */
  visit_retain_form_page = 'visit_retain_form_page',

  /**
   * 神策埋点
   * @value form_stay_pop
   * @Infomation 访问表单流程4表单页挽留弹窗
   */
  click_form_stay_pop = 'click_form_stay_pop',

  /**
   * 神策埋点
   * @value form_stay_pop
   * @Infomation 访问表单流程4表单页挽留表单
   */
  click_retain_form_page = 'click_retain_form_page',

  /**
   * 神策埋点
   * @value click_form_top_product_retain_leave
   * @Infomation 点击表单流程4最高价产品挽留弹窗的确认离开按钮
   */
  click_form_top_product_retain_leave = 'click_form_top_product_retain_leave',

  /**
   * 神策埋点
   * @value visit_result_top_product_retain_popup
   * @Infomation 访问结果页最高价产品挽留弹窗
   */
  visit_result_top_product_retain_popup = 'visit_result_top_product_retain_popup',

  /**
   * 神策埋点
   * @value click_result_top_product_retain_popup
   * @Infomation 点击结果页最高价产品挽留弹窗
   */
  click_result_top_product_retain_popup = 'click_result_top_product_retain_popup',

  /**
   * 神策埋点
   * @value click_hello_redirect
   * @Infomation 哈啰跳转企业微信数据集
   */
  click_hello_redirect = 'click_hello_redirect',

  /**
   * 神策埋点
   * @value visit_auto_submit_form
   * @Infomation 表单页-打开自动提交表单弹窗
   */
  visit_auto_submit_form = 'visit_auto_submit_form',
  /**
   * 神策埋点
   * @value click_auto_submit_form
   * @Infomation 表单页-点击自动提交表单弹窗
   */
  click_auto_submit_form = 'click_auto_submit_form',
  /**
   * 神策埋点
   * @value visit_guide_authorization
   * @Infomation 授权页-打开引导授权弹窗
   */
  visit_guide_authorization = 'visit_guide_authorization',
  /**
   * 神策埋点
   * @value click_guide_authorization
   * @Infomation 授权页-点击引导授权弹窗进行授权
   */
  click_guide_authorization = 'click_guide_authorization',
  /**
   * 神策埋点
   * @value visit_backend_monetization
   * @Infomation 授权页-打开引导点击后端产品弹窗
   */
  visit_backend_monetization = 'visit_backend_monetization',
  /**
   * 神策埋点
   * @value click_backend_monetization
   * @Infomation 授权页-点击引导点击后端产品弹窗
   */
  click_backend_monetization = 'click_backend_monetization',

  /**
   * 神策埋点
   * @value click_count_form_back
   * @Infomation 点击默认表单页返回
   * @field channelName 渠道名称
   */
  click_count_form_back = 'click_count_form_back',

  /**
   * 神策埋点
   * @value visit_2nd_back_guide_pop
   * @Infomation 访问二次返回引导后端产品弹窗
   * @field channelName 渠道名称
   * @field productName 匹配到的产品名称
   */
  visit_2nd_back_guide_pop = 'visit_2nd_back_guide_pop',

  /**
   * 神策埋点
   * @value click_count_2nd_back_guide_popup
   * @Infomation 点击二次返回引导后端产品弹窗
   * @field channelName 渠道名称
   * @field productName 匹配到的产品名称
   */
  click_count_2nd_back_guide_popup = 'click_count_2nd_back_guide_popup',

  /**
   * 神策埋点
   * @value visit_joint_login_guide
   * @Infomation 联登导联登-访问联登引导页
   */
  visit_joint_login_guide = 'visit_joint_login_guide',
  /**
   * 神策埋点
   * @value click_to_claim_now
   * @Infomation 联登导联登-点击马上领取
   */
  click_to_claim_now = 'click_to_claim_now',

  /**
   * 神策埋点
   * @value click_intermediate_form
   * @Infomation CRM跳企微，跳转表单
   */
  click_intermediate_form = 'click_intermediate_form',

  /**
   * 神策埋点
   * @value visit_huanbei_register_page
   * @Infomation 还呗访问量不准确问题，使用还呗 uid 进行埋点上报
   */
  visit_huanbei_register_page = 'visit_huanbei_register_page',

  /**
   * 神策埋点
   * @value visit_personal_Info_page
   * @Infomation 低产值流量-访问个人信息页
   */
  visit_personal_Info_page = 'visit_personal_Info_page',

  /**
   * 神策埋点
   * @value visit_common_contacts_page
   * @Infomation 低产值流量-访问常用联系人页
   */
  visit_common_contacts_page = 'visit_common_contacts_page',

  /**
   * 神策埋点
   * @value visit_idcard_Info_page
   * @Infomation 低产值流量-访问实名认证页
   */
  visit_idcard_Info_page = 'visit_idcard_Info_page',

  /**
   * 神策埋点
   * @value visit_id_retention_popup
   * @Infomation 低产值流量-访问实名认证挽留弹窗
   */
  visit_id_retention_popup = 'visit_id_retention_popup',

  /**
   * 神策埋点
   * @value click_id_popup
   * @Infomation 低产值流量-点击实名认证挽留弹窗领取额度
   */
  click_id_popup = 'click_id_popup',

  /**
   * 神策埋点
   * @value visit_disburse_auth_page
   * @Infomation 低产值流量-访问放款授权页
   */
  visit_disburse_auth_page = 'visit_disburse_auth_page',

  /**
   * 神策埋点
   * @value click_disburse_auth
   * @Infomation 低产值流量-点击放款授权
   */
  click_disburse_auth = 'click_disburse_auth',

  /**
   * 神策埋点
   * @value route_code_convert
   * @Infomation 路由码转换埋点，用于分析 adRouteCode 转换渠道码后的处理分支
   * @field original_url 用户打开页面时的完整原始 URL
   * @field ad_route_code URL 参数中的原始路由码 adRouteCode
   * @field route_code_api_response getAdChannelCodeByRouteCode 接口完整返回数据，JSON 字符串
   * @field route_code_convert_result 路由码转换结果：转换成功、路由码失效、接口异常
   * @field target_ad_channel_code 路由码转换出的目标渠道码
   * @field target_type 转换后的前端处理分支：普通流程、联登流程、CRM企微跳转、外部链接跳转、失效页
   * @field is_online 接口返回的 flgOnline，表示路由码是否在线
   * @field is_union 接口返回的 flgUnion，表示是否开启联登
   * @field product_id 接口返回的导流产品 ID
   * @field product_name 接口返回的导流产品名称
   * @field crm_jump_url 接口返回的 CRM 企微跳转地址
   * @field plan_target_url 接口返回的产品计划目标地址
   * @field final_url 前端准备跳转、替换或外跳的完整目标 URL
   * @field error_message 接口异常时的错误信息
   */
  route_code_convert = 'route_code_convert',

  /**
   * 神策埋点
   * @value click_by_period
   * @Infomation 时间段导流跳转埋点
   * @field adRouteCode 路由码
   * @field adChannelCode 渠道码
   * @field productName 导流产品名称
   * @field productUrl 导流产品跳转地址
   */
  click_by_period = 'click_by_period',

  /**
   * 神策埋点
   * @value visit_invalid_link_page
   * @Infomation 链接失效页访问埋点，用于分析用户进入失效页的原因
   * @field original_url 用户打开页面时的完整原始 URL
   * @field before_failure_url 用户跳转到 /failure 前的完整 URL
   * @field invalid_link_reason 链接失效原因：路由码已失效、渠道已禁用、未知原因
   * @field ad_route_code URL 参数中的原始路由码 adRouteCode
   * @field ad_channel_code 当前渠道码或路由码转换出的渠道码
   */
  visit_invalid_link_page = 'visit_invalid_link_page',
}
